import { AppController } from "../AppController";
var LicenseAlreadyOrderedPage = /** @class */ (function () {
    function LicenseAlreadyOrderedPage(_appController) {
        this._appController = _appController;
    }
    Object.defineProperty(LicenseAlreadyOrderedPage.prototype, "appController", {
        get: function () {
            return this._appController;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LicenseAlreadyOrderedPage.prototype, "organization", {
        get: function () {
            return this.appController.organization;
        },
        enumerable: true,
        configurable: true
    });
    return LicenseAlreadyOrderedPage;
}());
export { LicenseAlreadyOrderedPage };
